import React , { useState,useEffect } from 'react';
import {Button, CircularProgress} from '@material-ui/core';
import QRCode from 'qrcode.react';

import styled from 'styled-components';

const ContainerQR = styled.div`
display:flex;
margin:10px auto;`;

const ContainerButtons = styled.div`
display:flex;
justify-content:space-between;`;

const Whatsapp = () => 
{
    const [isLoading, setIsLoading] = useState(false);
    const [StatusWhatsapp, setStatusWhatsapp] = useState(undefined);
    const [StatusWhatsappText, setStatusWhatsappText] = useState(undefined);
    const [StatusWhatsappColor, setStatusWhatsappColor] = useState(undefined);

    const [StringQR, setStringQR] = useState(undefined);

    const NewSession = async ()=>
    {
        setIsLoading(true);
        try 
        {
            const {data} = await window.axios.post("/whatsapp/session");
            const {status,color,statusmsg} = data;
            setStatusWhatsapp(status);
            setStatusWhatsappColor(color);
            setStatusWhatsappText(statusmsg);
        } 
        catch (error) 
        {
            if (error.response) 
            {
                if (error.response.status === 400) 
                {
                    setStatusWhatsapp(error.response.data.status);
                }
            } 
            else if (error.request) 
            {
                setStatusWhatsappText("No se pudo conectar con el servidor");
                setStatusWhatsappColor("red");
            } 
        }
        setIsLoading(false);
    }

    const CheckStatus= async ()=>
    {
        setIsLoading(true);
        try 
        {

            const {data} = await window.axios.get("/whatsapp/status");
            const {status,QR,color,statusmsg} = data;
            setStatusWhatsapp(status);
            setStringQR(QR);
            setStatusWhatsappColor(color);
            setStatusWhatsappText(statusmsg);
        } 
        catch (error) 
        {
            if (error.response) 
            {
                if (error.response.status === 400) 
                {
                    const {data} = error.response;
                    
                    const {status,QR,color,statusmsg} = data;
                    setStatusWhatsapp(status);
                    setStringQR(QR);
                    setStatusWhatsappColor(color);
                    setStatusWhatsappText(statusmsg);
                }
            } 
            else if (error.request) 
            {
                setStatusWhatsappText("No se pudo conectar con el servidor");
                setStatusWhatsappColor("red");
            } 
        }
        setIsLoading(false);
    }

    const CloseSession= async ()=>
    {
        setIsLoading(true);
        try 
        {
            const {data} = await window.axios.delete("/whatsapp/session");
            const {status,color,statusmg} = data;
            setStatusWhatsapp(status);
            setStatusWhatsappColor(color);
            setStatusWhatsappText(statusmg);

        } 
        catch (error) 
        {
            if (error.response) 
            {
                if (error.response.status === 400) 
                {
                    const {data} = error.response;
                    
                    const {status,QR,color,statusmsg} = data;
                    setStatusWhatsapp(status);
                    setStringQR(QR);
                    setStatusWhatsappColor(color);
                    setStatusWhatsappText(statusmsg);
                }
            } 
            else if (error.request) 
            {
                setStatusWhatsappText("No se pudo conectar con el servidor");
                setStatusWhatsappColor("red");
            } 
        }
        setIsLoading(false);
    }

    useEffect(() =>
    {
        CheckStatus();
    },[]);

    const ScanQR = () =>
    {
        return <ContainerQR>
            <QRCode value={StringQR} width={200} height={200} style={{display:"flex",margin:"0 auto"}} renderAs='svg' />
           </ContainerQR>
    }

    if(isLoading)
    {
        return  <div>  
            <CircularProgress  size={100} style={{margin:"0 auto",display:"flex"}}/>
        </div>
    }

    return <div>
        {  StatusWhatsapp === "NOT_READY_YET"  ? <p style={{color:StatusWhatsappColor}}>Generando sesión</p> : <p style={{color:StatusWhatsappColor}}>STATUS: {StatusWhatsappText} </p>}
        
        <ContainerButtons>
            <Button variant='contained' color='primary' onClick={CheckStatus}>Comprobar estado</Button>
            {(StatusWhatsapp==="OK"  )   && <Button variant='contained' color='primary' onClick={CloseSession}>Cerrar sesión</Button>}
            <Button variant='contained' color='primary' onClick={NewSession}>Generar Sesión</Button>
        </ContainerButtons>
        {StatusWhatsapp === "QR" && <ScanQR/>}
    </div>
}

export default Whatsapp;